import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { MenuItem, Badge, Typography } from "@mui/material";
import Person2RoundedIcon from "@mui/icons-material/Person2Rounded";
import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import AppsDropdown from "../../components/Common/TopbarDropdown/AppsDropdown";
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import { useLocation } from "react-router-dom";
import logoLight from "../../assets/images/logo-light.png";
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

const Header = (props) => {
  const [search, setSearch] = useState(false);
  const [openPracMenu, setOpenPracMenu] = useState(false);
  const [practice, setPractice] = useState(false);
  const [reloadKey, setReloadKey] = useState(Date.now());
  const [practiceName, setPracticeName] = useState([]);
  const [fetchedUserType, setFetchedUserType] = useState("");
  const [practiceNameList, setPracticeNameList] = useState(
    localStorage.getItem("selectedPracticeName") || ""
  );


  const [currentPracticeId, setCurrentPracticeId] = useState(
    localStorage.getItem("default_practice") || ""
  );
  const userstype = localStorage.getItem("User_Type");
  const UserfullName = localStorage.getItem("UserName");
  const UserEmail =
    typeof window !== "undefined" ? localStorage.getItem("Emailaddress") : null;
  const token =
    typeof window !== "undefined" ? localStorage.getItem("Thyra_Token") : null;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const getUserPractices = async () => {
    if (!UserEmail) {
      console.error("UserEmail not found in localStorage");
      setPractice(false);
      return;
    }
    try {
      setPractice(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/User/getUserPractices?userEmail=${UserEmail}`,
        { headers }
      );

      const transformedData = response.map((item) => ({
        id: item.id,
        userName: item.userName,
        practiceName: item.practiceName,
        practiceId: item.practiceId,
        userType: item.userType || "",
        providerId: item.providerId || "",
      }));

      setPracticeName(transformedData);
      setPractice(false);

      if (transformedData[0]?.userType) {
        setFetchedUserType(transformedData[0].userType);
      }
    } catch (error) {
      console.error("Error fetching user practices:", error);
      setPractice(false);
      setPracticeName([]);
    }
  };
  const location = useLocation();

  useEffect(() => {
    setReloadKey(Date.now()); // Forces useEffect to rerun
  }, [location.pathname]);
  const getPracticeById = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Practices/getPracticeById?id=${id}`,
        { headers }
      );
      if (response.practiceName) {
        setPracticeNameList(response.practiceName);
        localStorage.setItem("selectedPracticeName", response.practiceName);
      }
    } catch (error) {
      console.error("Error fetching practice by ID:", error);
    }
  };

  useEffect(() => {
    if (!token || !UserEmail) {
      console.error("Token or UserEmail missing");
      return;
    }
    getUserPractices();
    if (
      currentPracticeId &&
      currentPracticeId !== "undefined" &&
      currentPracticeId !== "null"
    ) {
      getPracticeById(currentPracticeId);
    }
  }, [UserEmail, token]);

  useEffect(() => {
    if (
      currentPracticeId &&
      currentPracticeId !== "undefined" &&
      currentPracticeId !== "null"
    ) {
      getPracticeById(currentPracticeId);
    }
  }, [currentPracticeId]);

  const handleClosePracMenu = (practice) => {
    setOpenPracMenu(false);
    if (practice?.practiceId && practice.practiceId !== 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Practices/switchPractice?emailAddress=${UserEmail}&practiceId=${practice.practiceId}`,
          { headers }
        )
        .then((response) => {
          if (response?.token) {
            localStorage.setItem("Thyra_Token", response.token);
            localStorage.setItem("default_practice", practice.practiceId);
            localStorage.setItem("selectedPracticeName", practice.practiceName);
            if (practice.providerId) {
              localStorage.setItem("providerid", practice.providerId);
            }
            setCurrentPracticeId(practice.practiceId);
            setPracticeNameList(practice.practiceName);
            window.location.reload();
          } else {
            console.error("No token received in switch practice response");
          }
        })
        .catch((error) => {
          console.error("Error switching practice:", error);
        });
    }
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    const body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header d-flex justify-content-between align-items-center">
          {/* Left Side: Menu Button and Logo */}
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="logo-dark" height="24" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="40" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="60" />
                </span>
              </Link>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id=" criticised-menu-btn"
              onClick={tToggle}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
          </div>

          {/* Center: Menu Button with Dropdown */}
          <div className="dropdown d-inline-block">
            <button
              type="button"
              style={{
                backgroundColor: "#2B7B7E",
                color: "#fff",
                fontSize: 15,
                textAlign: "left",
                borderRadius: "20px",
                padding: "8px 16px",
                border: "1px solid #1A847D",
                display: "flex",
                alignItems: "center",
                width: "fit-content",
                minWidth: "150px",
                maxWidth: "400px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => setOpenPracMenu(!openPracMenu)}
            >
              <i
                className="ri-menu-line me-4"
                style={{ color: "#fff", borderRadius: 8 }}
              />
              <span>{practiceNameList || "Select Practice"}</span>
            </button>
            <div
              className={
                openPracMenu
                  ? "dropdown-menu dropdown-menu-lg dropdown-menu-start p-0 show"
                  : "dropdown-menu dropdown-menu-lg dropdown-menu-start p-0"
              }
            >
              <div className="p-1">
                {practiceName.length > 0 ? (
                  practiceName.map((practice) => (
                    <MenuItem
                      key={practice.practiceId}
                      style={{
                        width: "100%",
                        backgroundColor: "#1B2C3F",
                        borderRadius: "20px",
                        marginTop: 8,
                        alignContent: "left",
                        color: "white",
                      }}
                      onClick={() => handleClosePracMenu(practice)}
                      selected={currentPracticeId === practice.practiceId}
                    >
                      <Badge
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        <Person2RoundedIcon
                          style={{
                            color: "#FFF",
                            borderRadius: "50%",
                            border: "2px dashed gray",
                          }}
                        />
                      </Badge>
                      <Typography style={{ marginLeft: "10px" }}>
                        {practice.practiceName}
                      </Typography>
                    </MenuItem>
                  ))
                ) : (
                  <div className="dropdown-item text-muted">
                    {practice ? "Loading..." : "No practices found"}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Side: Search, Apps, Fullscreen, Profile */}
          <div className="d-flex align-items-center">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => setSearch(!search)}
                type="button"
                className="btn header-item noti-icon"
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <div className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <AppsDropdown />

            {/* maximise box */}
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={toggleFullscreen}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>

            <ProfileMenu />
            <Typography
              sx={{
                color: "#424242",
                fontSize: 14, // You can adjust this to 12, 13, etc., for even smaller size
              }}
            >
              {userstype}
              <br />
              <Typography component="span" sx={{ fontSize: 12 }}>
                {UserfullName}
              </Typography>
            </Typography>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
